<script>
  export let vehicleItem;
  export let index;
</script>

<tr class={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
  <td class="px-2 py-2 whitespace-nowrap text-center text-xs font-medium text-gray-900">
    {vehicleItem.kenteken}
  </td>
  <td class="px-2 py-2 whitespace-nowrap text-xs text-gray-500">
    {vehicleItem.merk}
  </td>
  <td class="px-2 py-2 whitespace-nowrap text-xs text-gray-500">
    {vehicleItem.handelsbenaming}
  </td>
  <td class="px-2 py-2 whitespace-nowrap text-xs text-gray-500">
    {vehicleItem.eerste_kleur}
  </td>
  <td class="px-2 py-2 whitespace-nowrap text-xs text-gray-500">
    {vehicleItem.inrichting}
  </td>
</tr>